import React, { ChangeEventHandler } from 'react';
import { Box, TextareaAutosize, TextField } from '@mui/material';
import { FormikTouched } from 'formik/dist/types';

type Props = {
    name: any;
    placeholder?: string;
    required: false | boolean;
    value?: string | undefined;
    touched?: boolean | FormikTouched<any> | FormikTouched<any>[] | undefined;
    errors?: any;
    onChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
    type?: 'text' | 'big-text';
    disabled?: boolean;
    dominantColor?: string;
    icon?: JSX.Element | string | undefined;
};

const FieldTextAreaAutoSize = ({
    name,
    placeholder,
    required,
    value,
    touched,
    errors,
    onChange,
    type = 'text',
    disabled,
    dominantColor,
    icon,
}: Props) => {
    const color = dominantColor || '#36c';
    return (
        <TextField
            id={name}
            fullWidth
            name={name}
            required={required}
            value={value}
            placeholder={placeholder}
            disabled={disabled}
            helperText={touched ? errors : ''}
            error={touched && Boolean(errors)}
            onChange={onChange}
            InputProps={
                
                type === 'text'
                    ? {
                        endAdornment: icon ? <Box>{icon}</Box> : undefined,
                        inputProps: {
                            style: {
                                fontFamily: 'Lucida Sans',
                                fontSize: '15px',
                            },
                        },
                    }
                    : {
                        inputComponent: TextareaAutosize,
                        inputProps: {
                            style: {
                                height: '150px',
                                fontFamily: 'Lucida Sans',
                                fontSize: '15px',
                            },
                        },
                    }
            }
            sx={{
                width: '80%',
                '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                        borderColor: '#ccc',
                    },
                    '&:hover fieldset': {
                        borderColor: color,
                    },
                    '&.Mui-focused fieldset': {
                        borderColor: color,
                    },
                },
                '& label.Mui-focused': {
                    color: color,
                },
                '.MuiFormHelperText-root': {
                    textAlign: 'center',
                },
            }}
        />
    );
};

export default FieldTextAreaAutoSize;
